import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { PaginationConfig } from '@app/core/_config/pagination.config';
import { ClientSkuPriceOverrideService } from '@app/core/client-sku-price-override/client-sku-price-override.service';
import { PaginationInterface } from '@app/interfaces/pagination.model';
import { PaginatorEventInterface } from '@app/interfaces/table.interface';

@Component({
  selector: 'cnc-client-price-overrides',
  templateUrl: './client-price-overrides.component.html',
  styleUrls: ['./client-price-overrides.component.scss'],
})
export class ClientPriceOverridesComponent implements OnInit {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _pagination = new BehaviorSubject<PaginationInterface>(
    <PaginationInterface>{},
  );
  pagination$ = this._pagination.asObservable();
  loading$ = this._loading.asObservable();

  @Input() rfqId :number;
  clientsPriceOverride :ClientPriceOverride[];
  paginationConfig = PaginationConfig;
  queryParams :{
    [param :string] :string | string[];
  } = {};

  constructor(private priceOverrideService :ClientSkuPriceOverrideService) {}

  ngOnInit() :void {
    this.loadClientSkuPriceOverrides(this.queryParams);
  }

  onPaginationEvent(paginator :PaginatorEventInterface) :void {
    this.queryParams = {
      ...this.queryParams,
      limit: paginator.pageSize.toString(),
      page: (paginator.pageIndex + 1).toString(),
    };
    this.loadClientSkuPriceOverrides(this.queryParams);
  }

  private loadClientSkuPriceOverrides(params :{
    [param :string] :string | string[];
  }) :void {
    this._loading.next(true);
    params.rfqId = this.rfqId.toString();
    this.priceOverrideService.getSkuPriceOverrideClients(params).subscribe(
      (resp :any) => {
        if (resp && resp.data) {
          this.clientsPriceOverride = resp.data.map((row :any) => {
            return {
              businessAccountId: row.business_account.id,
              businessName: row.business_account.business_name,
              price: row.price,
            };
          });
        }
        this._pagination.next(resp);
        this._loading.next(false);
      },
      (_) => {
        this._loading.next(false);
      },
    );
  }
}

interface ClientPriceOverride {
  businessAccountId :number;
  businessName :string;
  price :number;
}
